'use client';

import { useCallback, useEffect, useState } from 'react';

import { shouldDisplayPopup, shouldLoadWebAnalytics } from './cookies.js';
import PopupHandler from './popup.js';

export const PopupManager = (props) => {
  const { currentPage } = props;
  const [showPopup, setShowPopup] = useState(false);
  const [loadWebAnalytics, setLoadWebAnalytics] = useState(false);

  const cleanup = useCallback(() => setShowPopup(false), [setShowPopup]);

  useEffect(() => {
    setShowPopup(shouldDisplayPopup(currentPage));
    setLoadWebAnalytics(shouldLoadWebAnalytics());
  }, [currentPage]);

  return (
    <PopupHandler
      {...props}
      {...{ cleanup, showPopup, loadWebAnalytics, setLoadWebAnalytics }}
    />
  );
};

export default PopupManager;
